// Generated from Logo.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');


var serializedATN = ["\u0003\u0430\ud6d1\u8206\uad2d\u4417\uaef1\u8d80\uaadd",
    "\u0002v\u036b\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
    "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
    "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004",
    "F\tF\u0004G\tG\u0004H\tH\u0004I\tI\u0004J\tJ\u0004K\tK\u0004L\tL\u0004",
    "M\tM\u0004N\tN\u0004O\tO\u0004P\tP\u0004Q\tQ\u0004R\tR\u0004S\tS\u0004",
    "T\tT\u0004U\tU\u0004V\tV\u0004W\tW\u0004X\tX\u0004Y\tY\u0004Z\tZ\u0004",
    "[\t[\u0004\\\t\\\u0004]\t]\u0004^\t^\u0004_\t_\u0004`\t`\u0004a\ta\u0004",
    "b\tb\u0004c\tc\u0004d\td\u0004e\te\u0004f\tf\u0004g\tg\u0004h\th\u0004",
    "i\ti\u0004j\tj\u0004k\tk\u0004l\tl\u0004m\tm\u0004n\tn\u0004o\to\u0004",
    "p\tp\u0004q\tq\u0004r\tr\u0004s\ts\u0004t\tt\u0004u\tu\u0003\u0002\u0003",
    "\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003",
    "\u0005\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003\b\u0003",
    "\b\u0003\t\u0003\t\u0003\t\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003",
    "\f\u0003\f\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000e",
    "\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011",
    "\u0003\u0011\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013",
    "\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0016",
    "\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0017",
    "\u0003\u0017\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u001a",
    "\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a",
    "\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001c",
    "\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c",
    "\u0003\u001c\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d",
    "\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e",
    "\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003 ",
    "\u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003",
    "!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003\"\u0003\"\u0003",
    "\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003#\u0003",
    "#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003$\u0003$\u0003",
    "$\u0003$\u0003$\u0003$\u0003$\u0003%\u0003%\u0003%\u0003%\u0003%\u0003",
    "&\u0003&\u0003&\u0003&\u0003&\u0003&\u0003&\u0003\'\u0003\'\u0003\'",
    "\u0003\'\u0003\'\u0003\'\u0003(\u0003(\u0003(\u0003(\u0003(\u0003)\u0003",
    ")\u0003)\u0003)\u0003)\u0003)\u0003*\u0003*\u0003*\u0003+\u0003+\u0003",
    "+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003-\u0003",
    "-\u0003-\u0003.\u0003.\u0003.\u0003.\u0003.\u0003/\u0003/\u0003/\u0003",
    "/\u0003/\u0003/\u0003/\u0003/\u0003/\u00030\u00030\u00030\u00031\u0003",
    "1\u00031\u00031\u00031\u00031\u00032\u00032\u00032\u00033\u00033\u0003",
    "3\u00033\u00033\u00034\u00034\u00034\u00035\u00035\u00035\u00035\u0003",
    "5\u00035\u00035\u00035\u00035\u00035\u00035\u00035\u00036\u00036\u0003",
    "6\u00036\u00036\u00036\u00037\u00037\u00037\u00037\u00037\u00038\u0003",
    "8\u00038\u00038\u00038\u00039\u00039\u00039\u0003:\u0003:\u0003:\u0003",
    ";\u0003;\u0003;\u0003;\u0003;\u0003;\u0003<\u0003<\u0003<\u0003=\u0003",
    "=\u0003=\u0003=\u0003=\u0003=\u0003=\u0003=\u0003>\u0003>\u0003>\u0003",
    "?\u0003?\u0003?\u0003?\u0003?\u0003?\u0003?\u0003?\u0003?\u0003@\u0003",
    "@\u0003@\u0003@\u0003A\u0003A\u0003A\u0003A\u0003A\u0003A\u0003A\u0003",
    "A\u0003A\u0003B\u0003B\u0003B\u0003C\u0003C\u0003C\u0003C\u0003C\u0003",
    "C\u0003C\u0003C\u0003C\u0003C\u0003C\u0003D\u0003D\u0003D\u0003E\u0003",
    "E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003",
    "F\u0003F\u0003F\u0003F\u0003F\u0003F\u0003G\u0003G\u0003G\u0003G\u0003",
    "G\u0003G\u0003G\u0003G\u0003G\u0003G\u0003G\u0003G\u0003H\u0003H\u0003",
    "H\u0003H\u0003H\u0003H\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003",
    "I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003J\u0003",
    "J\u0003J\u0003J\u0003J\u0003K\u0003K\u0003K\u0003K\u0003K\u0003L\u0003",
    "L\u0003L\u0003L\u0003L\u0003L\u0003M\u0003M\u0003M\u0003M\u0003M\u0003",
    "N\u0003N\u0003N\u0003N\u0003N\u0003O\u0003O\u0003O\u0003O\u0003O\u0003",
    "O\u0003O\u0003P\u0003P\u0003P\u0003P\u0003Q\u0003Q\u0003Q\u0003Q\u0003",
    "R\u0003R\u0003R\u0003R\u0003S\u0003S\u0003S\u0003S\u0003T\u0003T\u0003",
    "T\u0003T\u0003U\u0003U\u0003U\u0003U\u0003U\u0003U\u0003U\u0003V\u0003",
    "V\u0003V\u0003V\u0003V\u0003W\u0003W\u0003W\u0003W\u0003W\u0003W\u0003",
    "W\u0003X\u0003X\u0003X\u0003X\u0003X\u0003Y\u0003Y\u0003Y\u0003Y\u0003",
    "Y\u0003Y\u0003Y\u0003Z\u0003Z\u0003Z\u0003Z\u0003Z\u0003[\u0003[\u0003",
    "[\u0003[\u0003\\\u0003\\\u0003\\\u0003\\\u0003\\\u0003]\u0003]\u0003",
    "]\u0003]\u0003^\u0003^\u0003^\u0003^\u0003^\u0003^\u0003_\u0003_\u0003",
    "_\u0003_\u0003`\u0003`\u0003`\u0003`\u0003`\u0003`\u0003a\u0003a\u0003",
    "a\u0003a\u0003a\u0003b\u0003b\u0003b\u0003b\u0003b\u0003c\u0003c\u0003",
    "c\u0003c\u0003c\u0003c\u0003d\u0003d\u0003d\u0003d\u0003d\u0003d\u0003",
    "d\u0003d\u0003d\u0003d\u0003d\u0003d\u0003e\u0003e\u0003e\u0003e\u0003",
    "e\u0003e\u0003e\u0003f\u0003f\u0003f\u0003f\u0003f\u0003f\u0003f\u0003",
    "f\u0003f\u0003f\u0003f\u0003g\u0003g\u0003h\u0003h\u0003h\u0003i\u0003",
    "i\u0003j\u0003j\u0003j\u0003j\u0003j\u0003j\u0003j\u0003j\u0003j\u0003",
    "k\u0003k\u0003k\u0003k\u0003k\u0003k\u0003k\u0003k\u0003k\u0003k\u0003",
    "k\u0003k\u0003k\u0003k\u0003k\u0003l\u0003l\u0003l\u0003l\u0003l\u0003",
    "l\u0003l\u0003l\u0003l\u0003l\u0003l\u0003l\u0003l\u0003l\u0003l\u0003",
    "l\u0003l\u0003l\u0003m\u0003m\u0003m\u0003m\u0003m\u0003m\u0003m\u0003",
    "m\u0003m\u0003m\u0003m\u0003m\u0003m\u0003n\u0003n\u0003n\u0003o\u0003",
    "o\u0007o\u034e\no\fo\u000eo\u0351\u000bo\u0003p\u0003p\u0003q\u0003",
    "q\u0003r\u0006r\u0358\nr\rr\u000er\u0359\u0003s\u0003s\u0007s\u035e",
    "\ns\fs\u000es\u0361\u000bs\u0003t\u0005t\u0364\nt\u0003t\u0003t\u0003",
    "u\u0003u\u0003u\u0003u\u0002\u0002v\u0003\u0003\u0005\u0004\u0007\u0005",
    "\t\u0006\u000b\u0007\r\b\u000f\t\u0011\n\u0013\u000b\u0015\f\u0017\r",
    "\u0019\u000e\u001b\u000f\u001d\u0010\u001f\u0011!\u0012#\u0013%\u0014",
    "\'\u0015)\u0016+\u0017-\u0018/\u00191\u001a3\u001b5\u001c7\u001d9\u001e",
    ";\u001f= ?!A\"C#E$G%I&K\'M(O)Q*S+U,W-Y.[/]0_1a2c3e4g5i6k7m8o9q:s;u<",
    "w=y>{?}@\u007fA\u0081B\u0083C\u0085D\u0087E\u0089F\u008bG\u008dH\u008f",
    "I\u0091J\u0093K\u0095L\u0097M\u0099N\u009bO\u009dP\u009fQ\u00a1R\u00a3",
    "S\u00a5T\u00a7U\u00a9V\u00abW\u00adX\u00afY\u00b1Z\u00b3[\u00b5\\\u00b7",
    "]\u00b9^\u00bb_\u00bd`\u00bfa\u00c1b\u00c3c\u00c5d\u00c7e\u00c9f\u00cb",
    "g\u00cdh\u00cfi\u00d1j\u00d3k\u00d5l\u00d7m\u00d9n\u00dbo\u00ddp\u00df",
    "q\u00e1r\u00e3s\u00e5t\u00e7u\u00e9v\u0003\u0002\u0007\u0004\u0002C",
    "\\c|\u0006\u00022;C\\aac|\u0003\u00022;\u0004\u0002\f\f\u000f\u000f",
    "\u0005\u0002\u000b\f\u000f\u000f\"\"\u036e\u0002\u0003\u0003\u0002\u0002",
    "\u0002\u0002\u0005\u0003\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002",
    "\u0002\u0002\t\u0003\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002",
    "\u0002\u0002\r\u0003\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002",
    "\u0002\u0002\u0011\u0003\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002",
    "\u0002\u0002\u0015\u0003\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002",
    "\u0002\u0002\u0019\u0003\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002",
    "\u0002\u0002\u001d\u0003\u0002\u0002\u0002\u0002\u001f\u0003\u0002\u0002",
    "\u0002\u0002!\u0003\u0002\u0002\u0002\u0002#\u0003\u0002\u0002\u0002",
    "\u0002%\u0003\u0002\u0002\u0002\u0002\'\u0003\u0002\u0002\u0002\u0002",
    ")\u0003\u0002\u0002\u0002\u0002+\u0003\u0002\u0002\u0002\u0002-\u0003",
    "\u0002\u0002\u0002\u0002/\u0003\u0002\u0002\u0002\u00021\u0003\u0002",
    "\u0002\u0002\u00023\u0003\u0002\u0002\u0002\u00025\u0003\u0002\u0002",
    "\u0002\u00027\u0003\u0002\u0002\u0002\u00029\u0003\u0002\u0002\u0002",
    "\u0002;\u0003\u0002\u0002\u0002\u0002=\u0003\u0002\u0002\u0002\u0002",
    "?\u0003\u0002\u0002\u0002\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003",
    "\u0002\u0002\u0002\u0002E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002",
    "\u0002\u0002\u0002I\u0003\u0002\u0002\u0002\u0002K\u0003\u0002\u0002",
    "\u0002\u0002M\u0003\u0002\u0002\u0002\u0002O\u0003\u0002\u0002\u0002",
    "\u0002Q\u0003\u0002\u0002\u0002\u0002S\u0003\u0002\u0002\u0002\u0002",
    "U\u0003\u0002\u0002\u0002\u0002W\u0003\u0002\u0002\u0002\u0002Y\u0003",
    "\u0002\u0002\u0002\u0002[\u0003\u0002\u0002\u0002\u0002]\u0003\u0002",
    "\u0002\u0002\u0002_\u0003\u0002\u0002\u0002\u0002a\u0003\u0002\u0002",
    "\u0002\u0002c\u0003\u0002\u0002\u0002\u0002e\u0003\u0002\u0002\u0002",
    "\u0002g\u0003\u0002\u0002\u0002\u0002i\u0003\u0002\u0002\u0002\u0002",
    "k\u0003\u0002\u0002\u0002\u0002m\u0003\u0002\u0002\u0002\u0002o\u0003",
    "\u0002\u0002\u0002\u0002q\u0003\u0002\u0002\u0002\u0002s\u0003\u0002",
    "\u0002\u0002\u0002u\u0003\u0002\u0002\u0002\u0002w\u0003\u0002\u0002",
    "\u0002\u0002y\u0003\u0002\u0002\u0002\u0002{\u0003\u0002\u0002\u0002",
    "\u0002}\u0003\u0002\u0002\u0002\u0002\u007f\u0003\u0002\u0002\u0002",
    "\u0002\u0081\u0003\u0002\u0002\u0002\u0002\u0083\u0003\u0002\u0002\u0002",
    "\u0002\u0085\u0003\u0002\u0002\u0002\u0002\u0087\u0003\u0002\u0002\u0002",
    "\u0002\u0089\u0003\u0002\u0002\u0002\u0002\u008b\u0003\u0002\u0002\u0002",
    "\u0002\u008d\u0003\u0002\u0002\u0002\u0002\u008f\u0003\u0002\u0002\u0002",
    "\u0002\u0091\u0003\u0002\u0002\u0002\u0002\u0093\u0003\u0002\u0002\u0002",
    "\u0002\u0095\u0003\u0002\u0002\u0002\u0002\u0097\u0003\u0002\u0002\u0002",
    "\u0002\u0099\u0003\u0002\u0002\u0002\u0002\u009b\u0003\u0002\u0002\u0002",
    "\u0002\u009d\u0003\u0002\u0002\u0002\u0002\u009f\u0003\u0002\u0002\u0002",
    "\u0002\u00a1\u0003\u0002\u0002\u0002\u0002\u00a3\u0003\u0002\u0002\u0002",
    "\u0002\u00a5\u0003\u0002\u0002\u0002\u0002\u00a7\u0003\u0002\u0002\u0002",
    "\u0002\u00a9\u0003\u0002\u0002\u0002\u0002\u00ab\u0003\u0002\u0002\u0002",
    "\u0002\u00ad\u0003\u0002\u0002\u0002\u0002\u00af\u0003\u0002\u0002\u0002",
    "\u0002\u00b1\u0003\u0002\u0002\u0002\u0002\u00b3\u0003\u0002\u0002\u0002",
    "\u0002\u00b5\u0003\u0002\u0002\u0002\u0002\u00b7\u0003\u0002\u0002\u0002",
    "\u0002\u00b9\u0003\u0002\u0002\u0002\u0002\u00bb\u0003\u0002\u0002\u0002",
    "\u0002\u00bd\u0003\u0002\u0002\u0002\u0002\u00bf\u0003\u0002\u0002\u0002",
    "\u0002\u00c1\u0003\u0002\u0002\u0002\u0002\u00c3\u0003\u0002\u0002\u0002",
    "\u0002\u00c5\u0003\u0002\u0002\u0002\u0002\u00c7\u0003\u0002\u0002\u0002",
    "\u0002\u00c9\u0003\u0002\u0002\u0002\u0002\u00cb\u0003\u0002\u0002\u0002",
    "\u0002\u00cd\u0003\u0002\u0002\u0002\u0002\u00cf\u0003\u0002\u0002\u0002",
    "\u0002\u00d1\u0003\u0002\u0002\u0002\u0002\u00d3\u0003\u0002\u0002\u0002",
    "\u0002\u00d5\u0003\u0002\u0002\u0002\u0002\u00d7\u0003\u0002\u0002\u0002",
    "\u0002\u00d9\u0003\u0002\u0002\u0002\u0002\u00db\u0003\u0002\u0002\u0002",
    "\u0002\u00dd\u0003\u0002\u0002\u0002\u0002\u00df\u0003\u0002\u0002\u0002",
    "\u0002\u00e1\u0003\u0002\u0002\u0002\u0002\u00e3\u0003\u0002\u0002\u0002",
    "\u0002\u00e5\u0003\u0002\u0002\u0002\u0002\u00e7\u0003\u0002\u0002\u0002",
    "\u0002\u00e9\u0003\u0002\u0002\u0002\u0003\u00eb\u0003\u0002\u0002\u0002",
    "\u0005\u00ee\u0003\u0002\u0002\u0002\u0007\u00f2\u0003\u0002\u0002\u0002",
    "\t\u00f4\u0003\u0002\u0002\u0002\u000b\u00fb\u0003\u0002\u0002\u0002",
    "\r\u0101\u0003\u0002\u0002\u0002\u000f\u0103\u0003\u0002\u0002\u0002",
    "\u0011\u0105\u0003\u0002\u0002\u0002\u0013\u0108\u0003\u0002\u0002\u0002",
    "\u0015\u010a\u0003\u0002\u0002\u0002\u0017\u010c\u0003\u0002\u0002\u0002",
    "\u0019\u010e\u0003\u0002\u0002\u0002\u001b\u0111\u0003\u0002\u0002\u0002",
    "\u001d\u0114\u0003\u0002\u0002\u0002\u001f\u0117\u0003\u0002\u0002\u0002",
    "!\u0119\u0003\u0002\u0002\u0002#\u011b\u0003\u0002\u0002\u0002%\u011e",
    "\u0003\u0002\u0002\u0002\'\u0120\u0003\u0002\u0002\u0002)\u0122\u0003",
    "\u0002\u0002\u0002+\u0125\u0003\u0002\u0002\u0002-\u0127\u0003\u0002",
    "\u0002\u0002/\u012d\u0003\u0002\u0002\u00021\u0131\u0003\u0002\u0002",
    "\u00023\u0137\u0003\u0002\u0002\u00025\u013e\u0003\u0002\u0002\u0002",
    "7\u0143\u0003\u0002\u0002\u00029\u014b\u0003\u0002\u0002\u0002;\u0150",
    "\u0003\u0002\u0002\u0002=\u0156\u0003\u0002\u0002\u0002?\u015b\u0003",
    "\u0002\u0002\u0002A\u0165\u0003\u0002\u0002\u0002C\u016d\u0003\u0002",
    "\u0002\u0002E\u0177\u0003\u0002\u0002\u0002G\u0180\u0003\u0002\u0002",
    "\u0002I\u0187\u0003\u0002\u0002\u0002K\u018c\u0003\u0002\u0002\u0002",
    "M\u0193\u0003\u0002\u0002\u0002O\u0199\u0003\u0002\u0002\u0002Q\u019e",
    "\u0003\u0002\u0002\u0002S\u01a4\u0003\u0002\u0002\u0002U\u01a7\u0003",
    "\u0002\u0002\u0002W\u01aa\u0003\u0002\u0002\u0002Y\u01b2\u0003\u0002",
    "\u0002\u0002[\u01b5\u0003\u0002\u0002\u0002]\u01ba\u0003\u0002\u0002",
    "\u0002_\u01c3\u0003\u0002\u0002\u0002a\u01c6\u0003\u0002\u0002\u0002",
    "c\u01cc\u0003\u0002\u0002\u0002e\u01cf\u0003\u0002\u0002\u0002g\u01d4",
    "\u0003\u0002\u0002\u0002i\u01d7\u0003\u0002\u0002\u0002k\u01e3\u0003",
    "\u0002\u0002\u0002m\u01e9\u0003\u0002\u0002\u0002o\u01ee\u0003\u0002",
    "\u0002\u0002q\u01f3\u0003\u0002\u0002\u0002s\u01f6\u0003\u0002\u0002",
    "\u0002u\u01f9\u0003\u0002\u0002\u0002w\u01ff\u0003\u0002\u0002\u0002",
    "y\u0202\u0003\u0002\u0002\u0002{\u020a\u0003\u0002\u0002\u0002}\u020d",
    "\u0003\u0002\u0002\u0002\u007f\u0216\u0003\u0002\u0002\u0002\u0081\u021a",
    "\u0003\u0002\u0002\u0002\u0083\u0223\u0003\u0002\u0002\u0002\u0085\u0226",
    "\u0003\u0002\u0002\u0002\u0087\u0231\u0003\u0002\u0002\u0002\u0089\u0234",
    "\u0003\u0002\u0002\u0002\u008b\u023f\u0003\u0002\u0002\u0002\u008d\u0245",
    "\u0003\u0002\u0002\u0002\u008f\u0251\u0003\u0002\u0002\u0002\u0091\u0257",
    "\u0003\u0002\u0002\u0002\u0093\u0266\u0003\u0002\u0002\u0002\u0095\u026b",
    "\u0003\u0002\u0002\u0002\u0097\u0270\u0003\u0002\u0002\u0002\u0099\u0276",
    "\u0003\u0002\u0002\u0002\u009b\u027b\u0003\u0002\u0002\u0002\u009d\u0280",
    "\u0003\u0002\u0002\u0002\u009f\u0287\u0003\u0002\u0002\u0002\u00a1\u028b",
    "\u0003\u0002\u0002\u0002\u00a3\u028f\u0003\u0002\u0002\u0002\u00a5\u0293",
    "\u0003\u0002\u0002\u0002\u00a7\u0297\u0003\u0002\u0002\u0002\u00a9\u029b",
    "\u0003\u0002\u0002\u0002\u00ab\u02a2\u0003\u0002\u0002\u0002\u00ad\u02a7",
    "\u0003\u0002\u0002\u0002\u00af\u02ae\u0003\u0002\u0002\u0002\u00b1\u02b3",
    "\u0003\u0002\u0002\u0002\u00b3\u02ba\u0003\u0002\u0002\u0002\u00b5\u02bf",
    "\u0003\u0002\u0002\u0002\u00b7\u02c3\u0003\u0002\u0002\u0002\u00b9\u02c8",
    "\u0003\u0002\u0002\u0002\u00bb\u02cc\u0003\u0002\u0002\u0002\u00bd\u02d2",
    "\u0003\u0002\u0002\u0002\u00bf\u02d6\u0003\u0002\u0002\u0002\u00c1\u02dc",
    "\u0003\u0002\u0002\u0002\u00c3\u02e1\u0003\u0002\u0002\u0002\u00c5\u02e6",
    "\u0003\u0002\u0002\u0002\u00c7\u02ec\u0003\u0002\u0002\u0002\u00c9\u02f8",
    "\u0003\u0002\u0002\u0002\u00cb\u02ff\u0003\u0002\u0002\u0002\u00cd\u030a",
    "\u0003\u0002\u0002\u0002\u00cf\u030c\u0003\u0002\u0002\u0002\u00d1\u030f",
    "\u0003\u0002\u0002\u0002\u00d3\u0311\u0003\u0002\u0002\u0002\u00d5\u031a",
    "\u0003\u0002\u0002\u0002\u00d7\u0329\u0003\u0002\u0002\u0002\u00d9\u033b",
    "\u0003\u0002\u0002\u0002\u00db\u0348\u0003\u0002\u0002\u0002\u00dd\u034b",
    "\u0003\u0002\u0002\u0002\u00df\u0352\u0003\u0002\u0002\u0002\u00e1\u0354",
    "\u0003\u0002\u0002\u0002\u00e3\u0357\u0003\u0002\u0002\u0002\u00e5\u035b",
    "\u0003\u0002\u0002\u0002\u00e7\u0363\u0003\u0002\u0002\u0002\u00e9\u0367",
    "\u0003\u0002\u0002\u0002\u00eb\u00ec\u0007v\u0002\u0002\u00ec\u00ed",
    "\u0007q\u0002\u0002\u00ed\u0004\u0003\u0002\u0002\u0002\u00ee\u00ef",
    "\u0007g\u0002\u0002\u00ef\u00f0\u0007p\u0002\u0002\u00f0\u00f1\u0007",
    "f\u0002\u0002\u00f1\u0006\u0003\u0002\u0002\u0002\u00f2\u00f3\u0007",
    "<\u0002\u0002\u00f3\b\u0003\u0002\u0002\u0002\u00f4\u00f5\u0007t\u0002",
    "\u0002\u00f5\u00f6\u0007g\u0002\u0002\u00f6\u00f7\u0007r\u0002\u0002",
    "\u00f7\u00f8\u0007g\u0002\u0002\u00f8\u00f9\u0007c\u0002\u0002\u00f9",
    "\u00fa\u0007v\u0002\u0002\u00fa\n\u0003\u0002\u0002\u0002\u00fb\u00fc",
    "\u0007y\u0002\u0002\u00fc\u00fd\u0007j\u0002\u0002\u00fd\u00fe\u0007",
    "k\u0002\u0002\u00fe\u00ff\u0007n\u0002\u0002\u00ff\u0100\u0007g\u0002",
    "\u0002\u0100\f\u0003\u0002\u0002\u0002\u0101\u0102\u0007]\u0002\u0002",
    "\u0102\u000e\u0003\u0002\u0002\u0002\u0103\u0104\u0007_\u0002\u0002",
    "\u0104\u0010\u0003\u0002\u0002\u0002\u0105\u0106\u0007k\u0002\u0002",
    "\u0106\u0107\u0007h\u0002\u0002\u0107\u0012\u0003\u0002\u0002\u0002",
    "\u0108\u0109\u0007>\u0002\u0002\u0109\u0014\u0003\u0002\u0002\u0002",
    "\u010a\u010b\u0007@\u0002\u0002\u010b\u0016\u0003\u0002\u0002\u0002",
    "\u010c\u010d\u0007?\u0002\u0002\u010d\u0018\u0003\u0002\u0002\u0002",
    "\u010e\u010f\u0007>\u0002\u0002\u010f\u0110\u0007?\u0002\u0002\u0110",
    "\u001a\u0003\u0002\u0002\u0002\u0111\u0112\u0007@\u0002\u0002\u0112",
    "\u0113\u0007?\u0002\u0002\u0113\u001c\u0003\u0002\u0002\u0002\u0114",
    "\u0115\u0007#\u0002\u0002\u0115\u0116\u0007?\u0002\u0002\u0116\u001e",
    "\u0003\u0002\u0002\u0002\u0117\u0118\u0007-\u0002\u0002\u0118 \u0003",
    "\u0002\u0002\u0002\u0119\u011a\u0007/\u0002\u0002\u011a\"\u0003\u0002",
    "\u0002\u0002\u011b\u011c\u0007~\u0002\u0002\u011c\u011d\u0007~\u0002",
    "\u0002\u011d$\u0003\u0002\u0002\u0002\u011e\u011f\u0007,\u0002\u0002",
    "\u011f&\u0003\u0002\u0002\u0002\u0120\u0121\u00071\u0002\u0002\u0121",
    "(\u0003\u0002\u0002\u0002\u0122\u0123\u0007(\u0002\u0002\u0123\u0124",
    "\u0007(\u0002\u0002\u0124*\u0003\u0002\u0002\u0002\u0125\u0126\u0007",
    "#\u0002\u0002\u0126,\u0003\u0002\u0002\u0002\u0127\u0128\u0007d\u0002",
    "\u0002\u0128\u0129\u0007n\u0002\u0002\u0129\u012a\u0007c\u0002\u0002",
    "\u012a\u012b\u0007e\u0002\u0002\u012b\u012c\u0007m\u0002\u0002\u012c",
    ".\u0003\u0002\u0002\u0002\u012d\u012e\u0007t\u0002\u0002\u012e\u012f",
    "\u0007g\u0002\u0002\u012f\u0130\u0007f\u0002\u0002\u01300\u0003\u0002",
    "\u0002\u0002\u0131\u0132\u0007i\u0002\u0002\u0132\u0133\u0007t\u0002",
    "\u0002\u0133\u0134\u0007g\u0002\u0002\u0134\u0135\u0007g\u0002\u0002",
    "\u0135\u0136\u0007p\u0002\u0002\u01362\u0003\u0002\u0002\u0002\u0137",
    "\u0138\u0007{\u0002\u0002\u0138\u0139\u0007g\u0002\u0002\u0139\u013a",
    "\u0007n\u0002\u0002\u013a\u013b\u0007n\u0002\u0002\u013b\u013c\u0007",
    "q\u0002\u0002\u013c\u013d\u0007y\u0002\u0002\u013d4\u0003\u0002\u0002",
    "\u0002\u013e\u013f\u0007d\u0002\u0002\u013f\u0140\u0007n\u0002\u0002",
    "\u0140\u0141\u0007w\u0002\u0002\u0141\u0142\u0007g\u0002\u0002\u0142",
    "6\u0003\u0002\u0002\u0002\u0143\u0144\u0007o\u0002\u0002\u0144\u0145",
    "\u0007c\u0002\u0002\u0145\u0146\u0007i\u0002\u0002\u0146\u0147\u0007",
    "g\u0002\u0002\u0147\u0148\u0007p\u0002\u0002\u0148\u0149\u0007v\u0002",
    "\u0002\u0149\u014a\u0007c\u0002\u0002\u014a8\u0003\u0002\u0002\u0002",
    "\u014b\u014c\u0007e\u0002\u0002\u014c\u014d\u0007{\u0002\u0002\u014d",
    "\u014e\u0007c\u0002\u0002\u014e\u014f\u0007p\u0002\u0002\u014f:\u0003",
    "\u0002\u0002\u0002\u0150\u0151\u0007y\u0002\u0002\u0151\u0152\u0007",
    "j\u0002\u0002\u0152\u0153\u0007k\u0002\u0002\u0153\u0154\u0007v\u0002",
    "\u0002\u0154\u0155\u0007g\u0002\u0002\u0155<\u0003\u0002\u0002\u0002",
    "\u0156\u0157\u0007i\u0002\u0002\u0157\u0158\u0007t\u0002\u0002\u0158",
    "\u0159\u0007c\u0002\u0002\u0159\u015a\u0007{\u0002\u0002\u015a>\u0003",
    "\u0002\u0002\u0002\u015b\u015c\u0007n\u0002\u0002\u015c\u015d\u0007",
    "k\u0002\u0002\u015d\u015e\u0007i\u0002\u0002\u015e\u015f\u0007j\u0002",
    "\u0002\u015f\u0160\u0007v\u0002\u0002\u0160\u0161\u0007i\u0002\u0002",
    "\u0161\u0162\u0007t\u0002\u0002\u0162\u0163\u0007c\u0002\u0002\u0163",
    "\u0164\u0007{\u0002\u0002\u0164@\u0003\u0002\u0002\u0002\u0165\u0166",
    "\u0007f\u0002\u0002\u0166\u0167\u0007c\u0002\u0002\u0167\u0168\u0007",
    "t\u0002\u0002\u0168\u0169\u0007m\u0002\u0002\u0169\u016a\u0007t\u0002",
    "\u0002\u016a\u016b\u0007g\u0002\u0002\u016b\u016c\u0007f\u0002\u0002",
    "\u016cB\u0003\u0002\u0002\u0002\u016d\u016e\u0007f\u0002\u0002\u016e",
    "\u016f\u0007c\u0002\u0002\u016f\u0170\u0007t\u0002\u0002\u0170\u0171",
    "\u0007m\u0002\u0002\u0171\u0172\u0007i\u0002\u0002\u0172\u0173\u0007",
    "t\u0002\u0002\u0173\u0174\u0007g\u0002\u0002\u0174\u0175\u0007g\u0002",
    "\u0002\u0175\u0176\u0007p\u0002\u0002\u0176D\u0003\u0002\u0002\u0002",
    "\u0177\u0178\u0007f\u0002\u0002\u0178\u0179\u0007c\u0002\u0002\u0179",
    "\u017a\u0007t\u0002\u0002\u017a\u017b\u0007m\u0002\u0002\u017b\u017c",
    "\u0007d\u0002\u0002\u017c\u017d\u0007n\u0002\u0002\u017d\u017e\u0007",
    "w\u0002\u0002\u017e\u017f\u0007g\u0002\u0002\u017fF\u0003\u0002\u0002",
    "\u0002\u0180\u0181\u0007q\u0002\u0002\u0181\u0182\u0007t\u0002\u0002",
    "\u0182\u0183\u0007c\u0002\u0002\u0183\u0184\u0007p\u0002\u0002\u0184",
    "\u0185\u0007i\u0002\u0002\u0185\u0186\u0007g\u0002\u0002\u0186H\u0003",
    "\u0002\u0002\u0002\u0187\u0188\u0007r\u0002\u0002\u0188\u0189\u0007",
    "k\u0002\u0002\u0189\u018a\u0007p\u0002\u0002\u018a\u018b\u0007m\u0002",
    "\u0002\u018bJ\u0003\u0002\u0002\u0002\u018c\u018d\u0007r\u0002\u0002",
    "\u018d\u018e\u0007w\u0002\u0002\u018e\u018f\u0007t\u0002\u0002\u018f",
    "\u0190\u0007r\u0002\u0002\u0190\u0191\u0007n\u0002\u0002\u0191\u0192",
    "\u0007g\u0002\u0002\u0192L\u0003\u0002\u0002\u0002\u0193\u0194\u0007",
    "d\u0002\u0002\u0194\u0195\u0007t\u0002\u0002\u0195\u0196\u0007q\u0002",
    "\u0002\u0196\u0197\u0007y\u0002\u0002\u0197\u0198\u0007p\u0002\u0002",
    "\u0198N\u0003\u0002\u0002\u0002\u0199\u019a\u0007o\u0002\u0002\u019a",
    "\u019b\u0007c\u0002\u0002\u019b\u019c\u0007m\u0002\u0002\u019c\u019d",
    "\u0007g\u0002\u0002\u019dP\u0003\u0002\u0002\u0002\u019e\u019f\u0007",
    "r\u0002\u0002\u019f\u01a0\u0007t\u0002\u0002\u01a0\u01a1\u0007k\u0002",
    "\u0002\u01a1\u01a2\u0007p\u0002\u0002\u01a2\u01a3\u0007v\u0002\u0002",
    "\u01a3R\u0003\u0002\u0002\u0002\u01a4\u01a5\u0007r\u0002\u0002\u01a5",
    "\u01a6\u0007t\u0002\u0002\u01a6T\u0003\u0002\u0002\u0002\u01a7\u01a8",
    "\u0007h\u0002\u0002\u01a8\u01a9\u0007f\u0002\u0002\u01a9V\u0003\u0002",
    "\u0002\u0002\u01aa\u01ab\u0007h\u0002\u0002\u01ab\u01ac\u0007q\u0002",
    "\u0002\u01ac\u01ad\u0007t\u0002\u0002\u01ad\u01ae\u0007y\u0002\u0002",
    "\u01ae\u01af\u0007c\u0002\u0002\u01af\u01b0\u0007t\u0002\u0002\u01b0",
    "\u01b1\u0007f\u0002\u0002\u01b1X\u0003\u0002\u0002\u0002\u01b2\u01b3",
    "\u0007d\u0002\u0002\u01b3\u01b4\u0007m\u0002\u0002\u01b4Z\u0003\u0002",
    "\u0002\u0002\u01b5\u01b6\u0007d\u0002\u0002\u01b6\u01b7\u0007c\u0002",
    "\u0002\u01b7\u01b8\u0007e\u0002\u0002\u01b8\u01b9\u0007m\u0002\u0002",
    "\u01b9\\\u0003\u0002\u0002\u0002\u01ba\u01bb\u0007d\u0002\u0002\u01bb",
    "\u01bc\u0007c\u0002\u0002\u01bc\u01bd\u0007e\u0002\u0002\u01bd\u01be",
    "\u0007m\u0002\u0002\u01be\u01bf\u0007y\u0002\u0002\u01bf\u01c0\u0007",
    "c\u0002\u0002\u01c0\u01c1\u0007t\u0002\u0002\u01c1\u01c2\u0007f\u0002",
    "\u0002\u01c2^\u0003\u0002\u0002\u0002\u01c3\u01c4\u0007t\u0002\u0002",
    "\u01c4\u01c5\u0007v\u0002\u0002\u01c5`\u0003\u0002\u0002\u0002\u01c6",
    "\u01c7\u0007t\u0002\u0002\u01c7\u01c8\u0007k\u0002\u0002\u01c8\u01c9",
    "\u0007i\u0002\u0002\u01c9\u01ca\u0007j\u0002\u0002\u01ca\u01cb\u0007",
    "v\u0002\u0002\u01cbb\u0003\u0002\u0002\u0002\u01cc\u01cd\u0007n\u0002",
    "\u0002\u01cd\u01ce\u0007v\u0002\u0002\u01ced\u0003\u0002\u0002\u0002",
    "\u01cf\u01d0\u0007n\u0002\u0002\u01d0\u01d1\u0007g\u0002\u0002\u01d1",
    "\u01d2\u0007h\u0002\u0002\u01d2\u01d3\u0007v\u0002\u0002\u01d3f\u0003",
    "\u0002\u0002\u0002\u01d4\u01d5\u0007e\u0002\u0002\u01d5\u01d6\u0007",
    "u\u0002\u0002\u01d6h\u0003\u0002\u0002\u0002\u01d7\u01d8\u0007e\u0002",
    "\u0002\u01d8\u01d9\u0007n\u0002\u0002\u01d9\u01da\u0007g\u0002\u0002",
    "\u01da\u01db\u0007c\u0002\u0002\u01db\u01dc\u0007t\u0002\u0002\u01dc",
    "\u01dd\u0007u\u0002\u0002\u01dd\u01de\u0007e\u0002\u0002\u01de\u01df",
    "\u0007t\u0002\u0002\u01df\u01e0\u0007g\u0002\u0002\u01e0\u01e1\u0007",
    "g\u0002\u0002\u01e1\u01e2\u0007p\u0002\u0002\u01e2j\u0003\u0002\u0002",
    "\u0002\u01e3\u01e4\u0007t\u0002\u0002\u01e4\u01e5\u0007g\u0002\u0002",
    "\u01e5\u01e6\u0007v\u0002\u0002\u01e6\u01e7\u0007t\u0002\u0002\u01e7",
    "\u01e8\u0007{\u0002\u0002\u01e8l\u0003\u0002\u0002\u0002\u01e9\u01ea",
    "\u0007p\u0002\u0002\u01ea\u01eb\u0007g\u0002\u0002\u01eb\u01ec\u0007",
    "z\u0002\u0002\u01ec\u01ed\u0007v\u0002\u0002\u01edn\u0003\u0002\u0002",
    "\u0002\u01ee\u01ef\u0007n\u0002\u0002\u01ef\u01f0\u0007c\u0002\u0002",
    "\u01f0\u01f1\u0007u\u0002\u0002\u01f1\u01f2\u0007v\u0002\u0002\u01f2",
    "p\u0003\u0002\u0002\u0002\u01f3\u01f4\u0007e\u0002\u0002\u01f4\u01f5",
    "\u0007v\u0002\u0002\u01f5r\u0003\u0002\u0002\u0002\u01f6\u01f7\u0007",
    "r\u0002\u0002\u01f7\u01f8\u0007w\u0002\u0002\u01f8t\u0003\u0002\u0002",
    "\u0002\u01f9\u01fa\u0007r\u0002\u0002\u01fa\u01fb\u0007g\u0002\u0002",
    "\u01fb\u01fc\u0007p\u0002\u0002\u01fc\u01fd\u0007w\u0002\u0002\u01fd",
    "\u01fe\u0007r\u0002\u0002\u01fev\u0003\u0002\u0002\u0002\u01ff\u0200",
    "\u0007r\u0002\u0002\u0200\u0201\u0007f\u0002\u0002\u0201x\u0003\u0002",
    "\u0002\u0002\u0202\u0203\u0007r\u0002\u0002\u0203\u0204\u0007g\u0002",
    "\u0002\u0204\u0205\u0007p\u0002\u0002\u0205\u0206\u0007f\u0002\u0002",
    "\u0206\u0207\u0007q\u0002\u0002\u0207\u0208\u0007y\u0002\u0002\u0208",
    "\u0209\u0007p\u0002\u0002\u0209z\u0003\u0002\u0002\u0002\u020a\u020b",
    "\u0007r\u0002\u0002\u020b\u020c\u0007g\u0002\u0002\u020c|\u0003\u0002",
    "\u0002\u0002\u020d\u020e\u0007r\u0002\u0002\u020e\u020f\u0007g\u0002",
    "\u0002\u020f\u0210\u0007p\u0002\u0002\u0210\u0211\u0007g\u0002\u0002",
    "\u0211\u0212\u0007t\u0002\u0002\u0212\u0213\u0007c\u0002\u0002\u0213",
    "\u0214\u0007u\u0002\u0002\u0214\u0215\u0007g\u0002\u0002\u0215~\u0003",
    "\u0002\u0002\u0002\u0216\u0217\u0007r\u0002\u0002\u0217\u0218\u0007",
    "r\u0002\u0002\u0218\u0219\u0007v\u0002\u0002\u0219\u0080\u0003\u0002",
    "\u0002\u0002\u021a\u021b\u0007r\u0002\u0002\u021b\u021c\u0007g\u0002",
    "\u0002\u021c\u021d\u0007p\u0002\u0002\u021d\u021e\u0007r\u0002\u0002",
    "\u021e\u021f\u0007c\u0002\u0002\u021f\u0220\u0007k\u0002\u0002\u0220",
    "\u0221\u0007p\u0002\u0002\u0221\u0222\u0007v\u0002\u0002\u0222\u0082",
    "\u0003\u0002\u0002\u0002\u0223\u0224\u0007j\u0002\u0002\u0224\u0225",
    "\u0007v\u0002\u0002\u0225\u0084\u0003\u0002\u0002\u0002\u0226\u0227",
    "\u0007j\u0002\u0002\u0227\u0228\u0007k\u0002\u0002\u0228\u0229\u0007",
    "f\u0002\u0002\u0229\u022a\u0007g\u0002\u0002\u022a\u022b\u0007v\u0002",
    "\u0002\u022b\u022c\u0007w\u0002\u0002\u022c\u022d\u0007t\u0002\u0002",
    "\u022d\u022e\u0007v\u0002\u0002\u022e\u022f\u0007n\u0002\u0002\u022f",
    "\u0230\u0007g\u0002\u0002\u0230\u0086\u0003\u0002\u0002\u0002\u0231",
    "\u0232\u0007u\u0002\u0002\u0232\u0233\u0007v\u0002\u0002\u0233\u0088",
    "\u0003\u0002\u0002\u0002\u0234\u0235\u0007u\u0002\u0002\u0235\u0236",
    "\u0007j\u0002\u0002\u0236\u0237\u0007q\u0002\u0002\u0237\u0238\u0007",
    "y\u0002\u0002\u0238\u0239\u0007v\u0002\u0002\u0239\u023a\u0007w\u0002",
    "\u0002\u023a\u023b\u0007t\u0002\u0002\u023b\u023c\u0007v\u0002\u0002",
    "\u023c\u023d\u0007n\u0002\u0002\u023d\u023e\u0007g\u0002\u0002\u023e",
    "\u008a\u0003\u0002\u0002\u0002\u023f\u0240\u0007u\u0002\u0002\u0240",
    "\u0241\u0007g\u0002\u0002\u0241\u0242\u0007v\u0002\u0002\u0242\u0243",
    "\u0007r\u0002\u0002\u0243\u0244\u0007e\u0002\u0002\u0244\u008c\u0003",
    "\u0002\u0002\u0002\u0245\u0246\u0007u\u0002\u0002\u0246\u0247\u0007",
    "g\u0002\u0002\u0247\u0248\u0007v\u0002\u0002\u0248\u0249\u0007r\u0002",
    "\u0002\u0249\u024a\u0007g\u0002\u0002\u024a\u024b\u0007p\u0002\u0002",
    "\u024b\u024c\u0007e\u0002\u0002\u024c\u024d\u0007q\u0002\u0002\u024d",
    "\u024e\u0007n\u0002\u0002\u024e\u024f\u0007q\u0002\u0002\u024f\u0250",
    "\u0007t\u0002\u0002\u0250\u008e\u0003\u0002\u0002\u0002\u0251\u0252",
    "\u0007u\u0002\u0002\u0252\u0253\u0007g\u0002\u0002\u0253\u0254\u0007",
    "v\u0002\u0002\u0254\u0255\u0007u\u0002\u0002\u0255\u0256\u0007e\u0002",
    "\u0002\u0256\u0090\u0003\u0002\u0002\u0002\u0257\u0258\u0007u\u0002",
    "\u0002\u0258\u0259\u0007g\u0002\u0002\u0259\u025a\u0007v\u0002\u0002",
    "\u025a\u025b\u0007u\u0002\u0002\u025b\u025c\u0007e\u0002\u0002\u025c",
    "\u025d\u0007t\u0002\u0002\u025d\u025e\u0007g\u0002\u0002\u025e\u025f",
    "\u0007g\u0002\u0002\u025f\u0260\u0007p\u0002\u0002\u0260\u0261\u0007",
    "e\u0002\u0002\u0261\u0262\u0007q\u0002\u0002\u0262\u0263\u0007n\u0002",
    "\u0002\u0263\u0264\u0007q\u0002\u0002\u0264\u0265\u0007t\u0002\u0002",
    "\u0265\u0092\u0003\u0002\u0002\u0002\u0266\u0267\u0007j\u0002\u0002",
    "\u0267\u0268\u0007q\u0002\u0002\u0268\u0269\u0007o\u0002\u0002\u0269",
    "\u026a\u0007g\u0002\u0002\u026a\u0094\u0003\u0002\u0002\u0002\u026b",
    "\u026c\u0007u\u0002\u0002\u026c\u026d\u0007v\u0002\u0002\u026d\u026e",
    "\u0007q\u0002\u0002\u026e\u026f\u0007r\u0002\u0002\u026f\u0096\u0003",
    "\u0002\u0002\u0002\u0270\u0271\u0007u\u0002\u0002\u0271\u0272\u0007",
    "g\u0002\u0002\u0272\u0273\u0007v\u0002\u0002\u0273\u0274\u0007z\u0002",
    "\u0002\u0274\u0275\u0007{\u0002\u0002\u0275\u0098\u0003\u0002\u0002",
    "\u0002\u0276\u0277\u0007u\u0002\u0002\u0277\u0278\u0007g\u0002\u0002",
    "\u0278\u0279\u0007v\u0002\u0002\u0279\u027a\u0007z\u0002\u0002\u027a",
    "\u009a\u0003\u0002\u0002\u0002\u027b\u027c\u0007u\u0002\u0002\u027c",
    "\u027d\u0007g\u0002\u0002\u027d\u027e\u0007v\u0002\u0002\u027e\u027f",
    "\u0007{\u0002\u0002\u027f\u009c\u0003\u0002\u0002\u0002\u0280\u0281",
    "\u0007t\u0002\u0002\u0281\u0282\u0007c\u0002\u0002\u0282\u0283\u0007",
    "p\u0002\u0002\u0283\u0284\u0007f\u0002\u0002\u0284\u0285\u0007q\u0002",
    "\u0002\u0285\u0286\u0007o\u0002\u0002\u0286\u009e\u0003\u0002\u0002",
    "\u0002\u0287\u0288\u0007t\u0002\u0002\u0288\u0289\u0007p\u0002\u0002",
    "\u0289\u028a\u0007f\u0002\u0002\u028a\u00a0\u0003\u0002\u0002\u0002",
    "\u028b\u028c\u0007t\u0002\u0002\u028c\u028d\u0007c\u0002\u0002\u028d",
    "\u028e\u0007p\u0002\u0002\u028e\u00a2\u0003\u0002\u0002\u0002\u028f",
    "\u0290\u0007u\u0002\u0002\u0290\u0291\u0007k\u0002\u0002\u0291\u0292",
    "\u0007p\u0002\u0002\u0292\u00a4\u0003\u0002\u0002\u0002\u0293\u0294",
    "\u0007e\u0002\u0002\u0294\u0295\u0007q\u0002\u0002\u0295\u0296\u0007",
    "u\u0002\u0002\u0296\u00a6\u0003\u0002\u0002\u0002\u0297\u0298\u0007",
    "v\u0002\u0002\u0298\u0299\u0007c\u0002\u0002\u0299\u029a\u0007p\u0002",
    "\u0002\u029a\u00a8\u0003\u0002\u0002\u0002\u029b\u029c\u0007c\u0002",
    "\u0002\u029c\u029d\u0007t\u0002\u0002\u029d\u029e\u0007e\u0002\u0002",
    "\u029e\u029f\u0007u\u0002\u0002\u029f\u02a0\u0007k\u0002\u0002\u02a0",
    "\u02a1\u0007p\u0002\u0002\u02a1\u00aa\u0003\u0002\u0002\u0002\u02a2",
    "\u02a3\u0007c\u0002\u0002\u02a3\u02a4\u0007u\u0002\u0002\u02a4\u02a5",
    "\u0007k\u0002\u0002\u02a5\u02a6\u0007p\u0002\u0002\u02a6\u00ac\u0003",
    "\u0002\u0002\u0002\u02a7\u02a8\u0007c\u0002\u0002\u02a8\u02a9\u0007",
    "t\u0002\u0002\u02a9\u02aa\u0007e\u0002\u0002\u02aa\u02ab\u0007e\u0002",
    "\u0002\u02ab\u02ac\u0007q\u0002\u0002\u02ac\u02ad\u0007u\u0002\u0002",
    "\u02ad\u00ae\u0003\u0002\u0002\u0002\u02ae\u02af\u0007c\u0002\u0002",
    "\u02af\u02b0\u0007e\u0002\u0002\u02b0\u02b1\u0007q\u0002\u0002\u02b1",
    "\u02b2\u0007u\u0002\u0002\u02b2\u00b0\u0003\u0002\u0002\u0002\u02b3",
    "\u02b4\u0007c\u0002\u0002\u02b4\u02b5\u0007t\u0002\u0002\u02b5\u02b6",
    "\u0007e\u0002\u0002\u02b6\u02b7\u0007v\u0002\u0002\u02b7\u02b8\u0007",
    "c\u0002\u0002\u02b8\u02b9\u0007p\u0002\u0002\u02b9\u00b2\u0003\u0002",
    "\u0002\u0002\u02ba\u02bb\u0007c\u0002\u0002\u02bb\u02bc\u0007v\u0002",
    "\u0002\u02bc\u02bd\u0007c\u0002\u0002\u02bd\u02be\u0007p\u0002\u0002",
    "\u02be\u00b4\u0003\u0002\u0002\u0002\u02bf\u02c0\u0007c\u0002\u0002",
    "\u02c0\u02c1\u0007d\u0002\u0002\u02c1\u02c2\u0007u\u0002\u0002\u02c2",
    "\u00b6\u0003\u0002\u0002\u0002\u02c3\u02c4\u0007u\u0002\u0002\u02c4",
    "\u02c5\u0007s\u0002\u0002\u02c5\u02c6\u0007t\u0002\u0002\u02c6\u02c7",
    "\u0007v\u0002\u0002\u02c7\u00b8\u0003\u0002\u0002\u0002\u02c8\u02c9",
    "\u0007o\u0002\u0002\u02c9\u02ca\u0007q\u0002\u0002\u02ca\u02cb\u0007",
    "f\u0002\u0002\u02cb\u00ba\u0003\u0002\u0002\u0002\u02cc\u02cd\u0007",
    "r\u0002\u0002\u02cd\u02ce\u0007q\u0002\u0002\u02ce\u02cf\u0007y\u0002",
    "\u0002\u02cf\u02d0\u0007g\u0002\u0002\u02d0\u02d1\u0007t\u0002\u0002",
    "\u02d1\u00bc\u0003\u0002\u0002\u0002\u02d2\u02d3\u0007n\u0002\u0002",
    "\u02d3\u02d4\u0007q\u0002\u0002\u02d4\u02d5\u0007i\u0002\u0002\u02d5",
    "\u00be\u0003\u0002\u0002\u0002\u02d6\u02d7\u0007n\u0002\u0002\u02d7",
    "\u02d8\u0007q\u0002\u0002\u02d8\u02d9\u0007i\u0002\u0002\u02d9\u02da",
    "\u00073\u0002\u0002\u02da\u02db\u00072\u0002\u0002\u02db\u00c0\u0003",
    "\u0002\u0002\u0002\u02dc\u02dd\u0007y\u0002\u0002\u02dd\u02de\u0007",
    "c\u0002\u0002\u02de\u02df\u0007k\u0002\u0002\u02df\u02e0\u0007v\u0002",
    "\u0002\u02e0\u00c2\u0003\u0002\u0002\u0002\u02e1\u02e2\u0007y\u0002",
    "\u0002\u02e2\u02e3\u0007c\u0002\u0002\u02e3\u02e4\u0007u\u0002\u0002",
    "\u02e4\u02e5\u0007j\u0002\u0002\u02e5\u00c4\u0003\u0002\u0002\u0002",
    "\u02e6\u02e7\u0007u\u0002\u0002\u02e7\u02e8\u0007g\u0002\u0002\u02e8",
    "\u02e9\u0007v\u0002\u0002\u02e9\u02ea\u0007r\u0002\u0002\u02ea\u02eb",
    "\u0007y\u0002\u0002\u02eb\u00c6\u0003\u0002\u0002\u0002\u02ec\u02ed",
    "\u0007u\u0002\u0002\u02ed\u02ee\u0007g\u0002\u0002\u02ee\u02ef\u0007",
    "v\u0002\u0002\u02ef\u02f0\u0007r\u0002\u0002\u02f0\u02f1\u0007g\u0002",
    "\u0002\u02f1\u02f2\u0007p\u0002\u0002\u02f2\u02f3\u0007y\u0002\u0002",
    "\u02f3\u02f4\u0007k\u0002\u0002\u02f4\u02f5\u0007f\u0002\u0002\u02f5",
    "\u02f6\u0007v\u0002\u0002\u02f6\u02f7\u0007j\u0002\u0002\u02f7\u00c8",
    "\u0003\u0002\u0002\u0002\u02f8\u02f9\u0007e\u0002\u0002\u02f9\u02fa",
    "\u0007k\u0002\u0002\u02fa\u02fb\u0007t\u0002\u0002\u02fb\u02fc\u0007",
    "e\u0002\u0002\u02fc\u02fd\u0007n\u0002\u0002\u02fd\u02fe\u0007g\u0002",
    "\u0002\u02fe\u00ca\u0003\u0002\u0002\u0002\u02ff\u0300\u0007u\u0002",
    "\u0002\u0300\u0301\u0007g\u0002\u0002\u0301\u0302\u0007v\u0002\u0002",
    "\u0302\u0303\u0007j\u0002\u0002\u0303\u0304\u0007g\u0002\u0002\u0304",
    "\u0305\u0007c\u0002\u0002\u0305\u0306\u0007f\u0002\u0002\u0306\u0307",
    "\u0007k\u0002\u0002\u0307\u0308\u0007p\u0002\u0002\u0308\u0309\u0007",
    "i\u0002\u0002\u0309\u00cc\u0003\u0002\u0002\u0002\u030a\u030b\u0007",
    "0\u0002\u0002\u030b\u00ce\u0003\u0002\u0002\u0002\u030c\u030d\u0007",
    "r\u0002\u0002\u030d\u030e\u0007k\u0002\u0002\u030e\u00d0\u0003\u0002",
    "\u0002\u0002\u030f\u0310\u0007g\u0002\u0002\u0310\u00d2\u0003\u0002",
    "\u0002\u0002\u0311\u0312\u0007w\u0002\u0002\u0312\u0313\u0007p\u0002",
    "\u0002\u0313\u0314\u0007k\u0002\u0002\u0314\u0315\u0007v\u0002\u0002",
    "\u0315\u0316\u0007v\u0002\u0002\u0316\u0317\u0007g\u0002\u0002\u0317",
    "\u0318\u0007u\u0002\u0002\u0318\u0319\u0007v\u0002\u0002\u0319\u00d4",
    "\u0003\u0002\u0002\u0002\u031a\u031b\u0007e\u0002\u0002\u031b\u031c",
    "\u0007t\u0002\u0002\u031c\u031d\u0007g\u0002\u0002\u031d\u031e\u0007",
    "c\u0002\u0002\u031e\u031f\u0007v\u0002\u0002\u031f\u0320\u0007g\u0002",
    "\u0002\u0320\u0321\u0007v\u0002\u0002\u0321\u0322\u0007g\u0002\u0002",
    "\u0322\u0323\u0007u\u0002\u0002\u0323\u0324\u0007v\u0002\u0002\u0324",
    "\u0325\u0007e\u0002\u0002\u0325\u0326\u0007c\u0002\u0002\u0326\u0327",
    "\u0007u\u0002\u0002\u0327\u0328\u0007g\u0002\u0002\u0328\u00d6\u0003",
    "\u0002\u0002\u0002\u0329\u032a\u0007i\u0002\u0002\u032a\u032b\u0007",
    "g\u0002\u0002\u032b\u032c\u0007p\u0002\u0002\u032c\u032d\u0007g\u0002",
    "\u0002\u032d\u032e\u0007t\u0002\u0002\u032e\u032f\u0007c\u0002\u0002",
    "\u032f\u0330\u0007v\u0002\u0002\u0330\u0331\u0007g\u0002\u0002\u0331",
    "\u0332\u0007u\u0002\u0002\u0332\u0333\u0007q\u0002\u0002\u0333\u0334",
    "\u0007n\u0002\u0002\u0334\u0335\u0007w\u0002\u0002\u0335\u0336\u0007",
    "v\u0002\u0002\u0336\u0337\u0007k\u0002\u0002\u0337\u0338\u0007q\u0002",
    "\u0002\u0338\u0339\u0007p\u0002\u0002\u0339\u033a\u0007u\u0002\u0002",
    "\u033a\u00d8\u0003\u0002\u0002\u0002\u033b\u033c\u0007w\u0002\u0002",
    "\u033c\u033d\u0007p\u0002\u0002\u033d\u033e\u0007k\u0002\u0002\u033e",
    "\u033f\u0007v\u0002\u0002\u033f\u0340\u0007v\u0002\u0002\u0340\u0341",
    "\u0007g\u0002\u0002\u0341\u0342\u0007u\u0002\u0002\u0342\u0343\u0007",
    "v\u0002\u0002\u0343\u0344\u0007d\u0002\u0002\u0344\u0345\u0007q\u0002",
    "\u0002\u0345\u0346\u0007q\u0002\u0002\u0346\u0347\u0007m\u0002\u0002",
    "\u0347\u00da\u0003\u0002\u0002\u0002\u0348\u0349\u0007$\u0002\u0002",
    "\u0349\u034a\u0005\u00ddo\u0002\u034a\u00dc\u0003\u0002\u0002\u0002",
    "\u034b\u034f\t\u0002\u0002\u0002\u034c\u034e\t\u0003\u0002\u0002\u034d",
    "\u034c\u0003\u0002\u0002\u0002\u034e\u0351\u0003\u0002\u0002\u0002\u034f",
    "\u034d\u0003\u0002\u0002\u0002\u034f\u0350\u0003\u0002\u0002\u0002\u0350",
    "\u00de\u0003\u0002\u0002\u0002\u0351\u034f\u0003\u0002\u0002\u0002\u0352",
    "\u0353\u0007*\u0002\u0002\u0353\u00e0\u0003\u0002\u0002\u0002\u0354",
    "\u0355\u0007+\u0002\u0002\u0355\u00e2\u0003\u0002\u0002\u0002\u0356",
    "\u0358\t\u0004\u0002\u0002\u0357\u0356\u0003\u0002\u0002\u0002\u0358",
    "\u0359\u0003\u0002\u0002\u0002\u0359\u0357\u0003\u0002\u0002\u0002\u0359",
    "\u035a\u0003\u0002\u0002\u0002\u035a\u00e4\u0003\u0002\u0002\u0002\u035b",
    "\u035f\u0007=\u0002\u0002\u035c\u035e\n\u0005\u0002\u0002\u035d\u035c",
    "\u0003\u0002\u0002\u0002\u035e\u0361\u0003\u0002\u0002\u0002\u035f\u035d",
    "\u0003\u0002\u0002\u0002\u035f\u0360\u0003\u0002\u0002\u0002\u0360\u00e6",
    "\u0003\u0002\u0002\u0002\u0361\u035f\u0003\u0002\u0002\u0002\u0362\u0364",
    "\u0007\u000f\u0002\u0002\u0363\u0362\u0003\u0002\u0002\u0002\u0363\u0364",
    "\u0003\u0002\u0002\u0002\u0364\u0365\u0003\u0002\u0002\u0002\u0365\u0366",
    "\u0007\f\u0002\u0002\u0366\u00e8\u0003\u0002\u0002\u0002\u0367\u0368",
    "\t\u0006\u0002\u0002\u0368\u0369\u0003\u0002\u0002\u0002\u0369\u036a",
    "\bu\u0002\u0002\u036a\u00ea\u0003\u0002\u0002\u0002\u0007\u0002\u034f",
    "\u0359\u035f\u0363\u0003\b\u0002\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function LogoLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

LogoLexer.prototype = Object.create(antlr4.Lexer.prototype);
LogoLexer.prototype.constructor = LogoLexer;

LogoLexer.EOF = antlr4.Token.EOF;
LogoLexer.T__0 = 1;
LogoLexer.T__1 = 2;
LogoLexer.T__2 = 3;
LogoLexer.T__3 = 4;
LogoLexer.T__4 = 5;
LogoLexer.T__5 = 6;
LogoLexer.T__6 = 7;
LogoLexer.T__7 = 8;
LogoLexer.T__8 = 9;
LogoLexer.T__9 = 10;
LogoLexer.T__10 = 11;
LogoLexer.T__11 = 12;
LogoLexer.T__12 = 13;
LogoLexer.T__13 = 14;
LogoLexer.T__14 = 15;
LogoLexer.T__15 = 16;
LogoLexer.T__16 = 17;
LogoLexer.T__17 = 18;
LogoLexer.T__18 = 19;
LogoLexer.T__19 = 20;
LogoLexer.T__20 = 21;
LogoLexer.T__21 = 22;
LogoLexer.T__22 = 23;
LogoLexer.T__23 = 24;
LogoLexer.T__24 = 25;
LogoLexer.T__25 = 26;
LogoLexer.T__26 = 27;
LogoLexer.T__27 = 28;
LogoLexer.T__28 = 29;
LogoLexer.T__29 = 30;
LogoLexer.T__30 = 31;
LogoLexer.T__31 = 32;
LogoLexer.T__32 = 33;
LogoLexer.T__33 = 34;
LogoLexer.T__34 = 35;
LogoLexer.T__35 = 36;
LogoLexer.T__36 = 37;
LogoLexer.T__37 = 38;
LogoLexer.T__38 = 39;
LogoLexer.T__39 = 40;
LogoLexer.T__40 = 41;
LogoLexer.T__41 = 42;
LogoLexer.T__42 = 43;
LogoLexer.T__43 = 44;
LogoLexer.T__44 = 45;
LogoLexer.T__45 = 46;
LogoLexer.T__46 = 47;
LogoLexer.T__47 = 48;
LogoLexer.T__48 = 49;
LogoLexer.T__49 = 50;
LogoLexer.T__50 = 51;
LogoLexer.T__51 = 52;
LogoLexer.T__52 = 53;
LogoLexer.T__53 = 54;
LogoLexer.T__54 = 55;
LogoLexer.T__55 = 56;
LogoLexer.T__56 = 57;
LogoLexer.T__57 = 58;
LogoLexer.T__58 = 59;
LogoLexer.T__59 = 60;
LogoLexer.T__60 = 61;
LogoLexer.T__61 = 62;
LogoLexer.T__62 = 63;
LogoLexer.T__63 = 64;
LogoLexer.T__64 = 65;
LogoLexer.T__65 = 66;
LogoLexer.T__66 = 67;
LogoLexer.T__67 = 68;
LogoLexer.T__68 = 69;
LogoLexer.T__69 = 70;
LogoLexer.T__70 = 71;
LogoLexer.T__71 = 72;
LogoLexer.T__72 = 73;
LogoLexer.T__73 = 74;
LogoLexer.T__74 = 75;
LogoLexer.T__75 = 76;
LogoLexer.T__76 = 77;
LogoLexer.T__77 = 78;
LogoLexer.T__78 = 79;
LogoLexer.T__79 = 80;
LogoLexer.T__80 = 81;
LogoLexer.T__81 = 82;
LogoLexer.T__82 = 83;
LogoLexer.T__83 = 84;
LogoLexer.T__84 = 85;
LogoLexer.T__85 = 86;
LogoLexer.T__86 = 87;
LogoLexer.T__87 = 88;
LogoLexer.T__88 = 89;
LogoLexer.T__89 = 90;
LogoLexer.T__90 = 91;
LogoLexer.T__91 = 92;
LogoLexer.T__92 = 93;
LogoLexer.T__93 = 94;
LogoLexer.T__94 = 95;
LogoLexer.T__95 = 96;
LogoLexer.T__96 = 97;
LogoLexer.T__97 = 98;
LogoLexer.T__98 = 99;
LogoLexer.T__99 = 100;
LogoLexer.T__100 = 101;
LogoLexer.T__101 = 102;
LogoLexer.T__102 = 103;
LogoLexer.T__103 = 104;
LogoLexer.T__104 = 105;
LogoLexer.T__105 = 106;
LogoLexer.T__106 = 107;
LogoLexer.T__107 = 108;
LogoLexer.STRINGLITERAL = 109;
LogoLexer.STRING = 110;
LogoLexer.LPAREN = 111;
LogoLexer.RPAREN = 112;
LogoLexer.NUMBER = 113;
LogoLexer.COMMENT = 114;
LogoLexer.EOL = 115;
LogoLexer.WS = 116;


LogoLexer.modeNames = [ "DEFAULT_MODE" ];

LogoLexer.literalNames = [ null, "'to'", "'end'", "':'", "'repeat'", "'while'", 
                           "'['", "']'", "'if'", "'<'", "'>'", "'='", "'<='", 
                           "'>='", "'!='", "'+'", "'-'", "'||'", "'*'", 
                           "'/'", "'&&'", "'!'", "'black'", "'red'", "'green'", 
                           "'yellow'", "'blue'", "'magenta'", "'cyan'", 
                           "'white'", "'gray'", "'lightgray'", "'darkred'", 
                           "'darkgreen'", "'darkblue'", "'orange'", "'pink'", 
                           "'purple'", "'brown'", "'make'", "'print'", "'pr'", 
                           "'fd'", "'forward'", "'bk'", "'back'", "'backward'", 
                           "'rt'", "'right'", "'lt'", "'left'", "'cs'", 
                           "'clearscreen'", "'retry'", "'next'", "'last'", 
                           "'ct'", "'pu'", "'penup'", "'pd'", "'pendown'", 
                           "'pe'", "'penerase'", "'ppt'", "'penpaint'", 
                           "'ht'", "'hideturtle'", "'st'", "'showturtle'", 
                           "'setpc'", "'setpencolor'", "'setsc'", "'setscreencolor'", 
                           "'home'", "'stop'", "'setxy'", "'setx'", "'sety'", 
                           "'random'", "'rnd'", "'ran'", "'sin'", "'cos'", 
                           "'tan'", "'arcsin'", "'asin'", "'arccos'", "'acos'", 
                           "'arctan'", "'atan'", "'abs'", "'sqrt'", "'mod'", 
                           "'power'", "'log'", "'log10'", "'wait'", "'wash'", 
                           "'setpw'", "'setpenwidth'", "'circle'", "'setheading'", 
                           "'.'", "'pi'", "'e'", "'unittest'", "'createtestcase'", 
                           "'generatesolutions'", "'unittestbook'", null, 
                           null, "'('", "')'" ];

LogoLexer.symbolicNames = [ null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, null, null, null, 
                            null, null, null, null, null, "STRINGLITERAL", 
                            "STRING", "LPAREN", "RPAREN", "NUMBER", "COMMENT", 
                            "EOL", "WS" ];

LogoLexer.ruleNames = [ "T__0", "T__1", "T__2", "T__3", "T__4", "T__5", 
                        "T__6", "T__7", "T__8", "T__9", "T__10", "T__11", 
                        "T__12", "T__13", "T__14", "T__15", "T__16", "T__17", 
                        "T__18", "T__19", "T__20", "T__21", "T__22", "T__23", 
                        "T__24", "T__25", "T__26", "T__27", "T__28", "T__29", 
                        "T__30", "T__31", "T__32", "T__33", "T__34", "T__35", 
                        "T__36", "T__37", "T__38", "T__39", "T__40", "T__41", 
                        "T__42", "T__43", "T__44", "T__45", "T__46", "T__47", 
                        "T__48", "T__49", "T__50", "T__51", "T__52", "T__53", 
                        "T__54", "T__55", "T__56", "T__57", "T__58", "T__59", 
                        "T__60", "T__61", "T__62", "T__63", "T__64", "T__65", 
                        "T__66", "T__67", "T__68", "T__69", "T__70", "T__71", 
                        "T__72", "T__73", "T__74", "T__75", "T__76", "T__77", 
                        "T__78", "T__79", "T__80", "T__81", "T__82", "T__83", 
                        "T__84", "T__85", "T__86", "T__87", "T__88", "T__89", 
                        "T__90", "T__91", "T__92", "T__93", "T__94", "T__95", 
                        "T__96", "T__97", "T__98", "T__99", "T__100", "T__101", 
                        "T__102", "T__103", "T__104", "T__105", "T__106", 
                        "T__107", "STRINGLITERAL", "STRING", "LPAREN", "RPAREN", 
                        "NUMBER", "COMMENT", "EOL", "WS" ];

LogoLexer.grammarFileName = "Logo.g4";



exports.LogoLexer = LogoLexer;




//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-input/LogoLexer.js
// module id = ./src/app/interpreter/interpreter-input/LogoLexer.js
// module chunks = main